'use client';

import { type ReactNode } from 'react';
import MuiCard, { type CardProps as MuiCardProps } from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';

export interface CardProps extends MuiCardProps {
  title?: string;
  subheader?: string;
  actions?: ReactNode;
  headerAction?: ReactNode;
}

export function Card({ title, subheader, actions, headerAction, children, ...props }: CardProps) {
  return (
    <MuiCard {...props}>
      {(title || subheader) && <CardHeader title={title} subheader={subheader} action={headerAction} />}
      <CardContent>{children}</CardContent>
      {actions && <CardActions>{actions}</CardActions>}
    </MuiCard>
  );
}
